// extracted by mini-css-extract-plugin
export default {"formGroup":"styles_formGroup__8FcGP","formLabel":"styles_formLabel__TxDL5","formSelectWrapper":"styles_formSelectWrapper__Dpn2A","formSelect":"styles_formSelect__vkB2b"};